import { IconButton, Modal, Text } from "@carbon6/c6-frontend-design";
import type { ChangeEvent, ReactNode, SyntheticEvent } from "react";
import { hatcheryTextModes } from "@/app/theme";
import { HatModalHeader } from "@/components/modal";
import type { LabelDialogState } from "../LabelPageTypes";
import styles from "../LabelPage.module.css";
import { LabelDetailsFields } from "./LabelDetailsFields";

type LabelEditDialogProps = {
  dialog: Extract<LabelDialogState, { kind: "edit" }>;
  onClose: () => void;
  onColorChange: (color: number) => void;
  onDescriptionChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (event: SyntheticEvent<HTMLFormElement, SubmitEvent>) => void;
};

export function LabelEditDialog({
  dialog,
  onClose,
  onColorChange,
  onDescriptionChange,
  onSubmit,
}: LabelEditDialogProps): ReactNode {
  return (
    <Modal
      open
      onClose={onClose}
      size="md"
      closeOnBackdropClick={!dialog.submitting}
      closeOnEscape={!dialog.submitting}
      aria-labelledby="label-edit-dialog-title"
    >
      <HatModalHeader
        title="라벨을 편집합니다."
        titleId="label-edit-dialog-title"
        close={{ disabled: dialog.submitting }}
      />
      <form className={styles.dialogForm} onSubmit={onSubmit}>
        <Text variant={hatcheryTextModes["caption-bold"]} className={styles.dialogEyebrow}>
          {dialog.label.key} / {dialog.label.value}
        </Text>
        <div className={styles.fields}>
          <LabelDetailsFields
            color={dialog.form.color}
            colorFieldId="label-edit-color"
            description={dialog.form.description}
            disabled={dialog.submitting}
            onColorChange={onColorChange}
            onDescriptionChange={onDescriptionChange}
          />
        </div>
        {dialog.errorMessage ? (
          <Text
            variant={hatcheryTextModes["body-normal"]}
            className={styles.dialogError}
            role="alert"
          >
            {dialog.errorMessage}
          </Text>
        ) : null}
        <div className={styles.dialogActions}>
          <IconButton
            text="취소"
            type="button"
            variant="surface"
            disabled={dialog.submitting}
            onClick={onClose}
          />
          <IconButton
            text={dialog.submitting ? "저장 중" : "저장"}
            type="submit"
            variant="solid"
            disabled={dialog.submitting}
          />
        </div>
      </form>
    </Modal>
  );
}
